<template>
    <div>
        <zm-row>
            <!-- <zm-dropdown size="small" split-button type="primary" @click="uploadVisible = true" @command="handleCommand">
                Upload Tasks
                <zm-dropdown-menu slot="dropdown">
                    <zm-dropdown-item command="downloadTemplate">Download Template</zm-dropdown-item>
                </zm-dropdown-menu>
            </zm-dropdown> -->
            <zm-button size="small" plain type="primary" @click="showUpload" v-if="hasPermission" class="btn-in-line">Upload Tasks</zm-button>
            <zm-input size="small" v-model.trim="search" class="task-input" @keyup.enter.native="clickSearch()">
                <zm-button size="small" slot="append" icon="zm-icon-search" @click="clickSearch()"></zm-button>
            </zm-input>
            <zm-select size="small" v-model="select" class="task-select" @change="changeSearchType">
                <zm-option option-id="1" label="id" value="id"></zm-option>
                <zm-option option-id="2" label="originalTaskId" value="original"></zm-option>
            </zm-select>
        </zm-row>
        <zm-form inline>
            <zm-form-item label="Time">
                <div slot="label">
                    <tip label="Time" id="task-query-time"></tip>
                </div>
            <time-picker-option @setTimeRange="setTimeRange"
                ref="timePickerOption"></time-picker-option>
            </zm-form-item>
            <zm-form-item label="ConsumeCost">
                <div slot="label">
                    <tip label="ConsumeCost" id="task-query-consumeCost"></tip>
                </div>
            <zm-input-number size="small" v-model="filter.minConsumeCost" :min="0" :max="filter.maxConsumeCost" class="inline-number" placeholder="minConsumeCost"></zm-input-number>
            <span> - </span>
            <zm-input-number size="small" v-model="filter.maxConsumeCost" :min="filter.minConsumeCost" class="inline-number" placeholder="maxConsumeCost"></zm-input-number>
            </zm-form-item>
            <zm-form-item label="Name">
                <div slot="label">
                    <tip label="Name" id="task-query-name"></tip>
                </div>
            <zm-input size="small" v-model.trim="filter.name" class="task-input-in-line" placeholder="name"></zm-input>
            </zm-form-item>
            <zm-form-item label="Keyword">
                <div slot="label">
                    <tip label="Keyword" id="task-query-keyword"></tip>
                </div>
            <zm-input size="small" v-model.trim="filter.keyword" class="task-input-in-line" placeholder="keyword">
            </zm-input>
            </zm-form-item>
            <zm-form-item label="Group">
                <div slot="label">
                    <tip label="Group" id="task-query-group"></tip>
                </div>
            <zm-select size="small" v-model="filter.group" class="task-input-in-line select-with-prefix" placeholder="group" allow-create filterable clearable>
                <zm-option v-for="item in groups" :key="item" :value="item" :label="item"></zm-option>
            </zm-select>
            </zm-form-item>
            <zm-form-item label="Topic">
                <div slot="label">
                    <tip label="Topic" id="task-query-topic"></tip>
                </div>
            <zm-select size="small" v-model="filter.topicId" class="task-inline-select" clearable filterable placeholder="topic" @change="refreshLists" :loading="loadingTopic">
                <zm-option v-for="item in topicList" :key="item.id" :value="item.id" :label="item.name"></zm-option>
            </zm-select>
            </zm-form-item>
            <zm-form-item label="TaskType">
                <div slot="label">
                    <tip label="TaskType" id="task-query-taskType"></tip>
                </div>
            <zm-select size="small" v-model="filter.taskType" class="task-inline-select" clearable filterable placeholder="taskType" allow-create>
                <zm-option v-for="item in subtopics" :key="item" :value="item" :label="item"></zm-option>
            </zm-select>
            </zm-form-item>
            <zm-form-item label="Status">
                <div slot="label">
                    <tip label="Status" id="task-query-status"></tip>
                </div>
            <zm-select size="small" v-model="filter.status" class="task-status-select">
                <zm-option v-for="item in statusList" :key="item" :value="item" :label="item"></zm-option>
            </zm-select>
            </zm-form-item>
            <zm-button @click="searchByFilter()" type="icon" icon="zm-icon-search" size="small"></zm-button>
            <zm-button @click="deleteTasks()" type="icon" icon="zm-icon-delete" size="small" v-if="hasPermission"></zm-button>
            <zm-button @click="showTriggerTasks()" type="icon" v-if="hasPermission"
                title="batch trigger tasks" icon="zm-icon-play-circle-outline" size="small"></zm-button>
        </zm-form>
        <div class="table-container">
            <zm-table resizable border :data="parentList" v-loading="parentLoading" @expand-change="expandParentHandler" v-if="showParent">
                <zm-table-column type="expand">
                    <template slot-scope="props">
                        <zm-form label-position="left" inline class="demo-table-expand">
                            <!-- <zm-form-item label="id">
                                <span>{{ props.row.id }}</span>
                            </zm-form-item> -->
                            <zm-form-item label="taskId">
                                <span>{{ props.row.taskId }}</span>
                            </zm-form-item>
                            <zm-form-item label="originalTaskId" v-if="props.row.taskStatus === 'PRODUCED' || props.row.taskStatus === 'PRODUCE_FAILED' || props.row.taskStatus === 'REPRODUCED'">
                                <zm-button type="link" @click="doSearchOriginal(props.row.originalTaskId)" v-if="props.row.originalTaskId">{{props.row.taskId}}</zm-button>
                                <span v-else>null</span>
                            </zm-form-item>
                            <zm-form-item label="generateTime" v-if="props.row.taskStatus === 'PRODUCED' || props.row.taskStatus === 'PRODUCE_FAILED' || props.row.taskStatus === 'REPRODUCED'">
                                <span>{{ setTime('', '', props.row.generateTime) || 'null' }}</span>
                            </zm-form-item>
                            <zm-form-item label="group" v-if="props.row.taskStatus !== 'PRODUCED' && props.row.taskStatus !== 'PRODUCE_FAILED' && props.row.taskStatus !== 'REPRODUCED'">
                                <span>{{ props.row.group || 'null' }}</span>
                            </zm-form-item>
                            <zm-form-item label="consumeCost" v-if="props.row.taskStatus !== 'PRODUCED' && props.row.taskStatus !== 'PRODUCE_FAILED' && props.row.taskStatus !== 'REPRODUCED'">
                                <span>{{ props.row.consumeCost }}</span>
                            </zm-form-item>
                            <zm-form-item label="clientInfo">
                                <span>{{ props.row.clientInfo || 'null' }}</span>
                            </zm-form-item>
                            <zm-form-item label="subscriber" v-if="props.row.subscriber">
                                <span>{{ props.row.subscriber }}<b>({{ props.row.subscriberName }})</b></span>
                                <!-- <span v-else>null</span> -->
                            </zm-form-item>
                            <zm-form-item label="publisher" v-if="props.row.publisher">
                                <span>{{ props.row.publisher }}<b>({{ props.row.publisherName }})</b></span>
                                <!-- <span v-else>null</span> -->
                            </zm-form-item>
                            <zm-form-item label="topicId">
                                <span>
                                    <a @click="jumpToTopic(props.row.topicId)">{{ props.row.topicId }}</a>
                                    <a v-if="props.row.topicName">
                                        <zm-popover placement="bottom" width="500" trigger="click" popper-class="topic-detail-popover">
                                            <div>
                                                <span v-for="( value, key ) in props.row.topic" :key="key">
                                                    <p v-if="!/advancedFeatureMap|publishers|subscribers|createdTime|modifiedTime|name|id|currentRegion|owner|ttlDuration|ttlDurationTimeUnit/.test(key)">{{ key }}:{{ value }}</p>
                                                </span>
                                            </div>
                                            <b slot="reference">({{ props.row.topicName }})</b>
                                        </zm-popover>
                                    </a>
                                </span>
                            </zm-form-item>
                            <zm-form-item label="taskType">
                                <span>{{ props.row.taskType }}</span>
                            </zm-form-item>
                            <zm-form-item label="retryTimes" v-if="props.row.taskStatus !== 'PRODUCED'">
                                <span>{{ props.row.retryTimes }}</span>
                            </zm-form-item>
                            <zm-form-item label="reports">
                                <div v-if="props.row.reports">
                                    <div v-for="item of props.row.reports" :key="item"><span>{{item}}</span></div>
                                </div>
                                <span v-else>null</span>
                            </zm-form-item>
                            <!-- <zm-form-item label="body" label-width="0"> -->
                                <zm-form class="form-inside" label-width="100px">
                                    <zm-form-item label="payload">
                                        <zm-tag size="medium" v-if="props.row.hiddenEnable" type="warning">hidden</zm-tag>
                                        <zm-form v-else-if="props.row.payload && props.row.payload.payload && typeof props.row.payload.payload === 'object'" class="body-table-expand">
                                            <zm-form-item v-for="item in Object.keys(props.row.payload.payload)" :key="item" :label="item">
                                                <span>{{ props.row.payload.payload[item] }}</span>
                                                <span v-if="item === 'timestamp'">({{ setTime('', '', props.row.payload.payload[item]) }})</span>
                                            </zm-form-item>
                                        </zm-form>
                                        <span v-else-if="props.row.payload">{{ props.row.payload.payload }}</span>
                                    </zm-form-item>
                                    <zm-form-item label="metadata">
                                        <zm-form class="body-table-expand"
                                        v-if="props.row.payload && props.row.payload.metadata && typeof props.row.payload.metadata === 'object'">
                                            <zm-form-item v-for="item in Object.keys(props.row.payload.metadata)" :key="item" :label="item">
                                                <span>{{ props.row.payload.metadata[item] }}</span>
                                                <span v-if="item === 'messageTimestamp'">({{ setTime('', '', props.row.payload.metadata[item]) }})</span>
                                            </zm-form-item>
                                        </zm-form>
                                        <span v-else-if="props.row.payload">{{ props.row.payload.metadata }}</span>
                                    </zm-form-item>
                                    <zm-form-item label="taskContext">
                                        <zm-form class="body-table-expand"
                                        v-if="props.row.payload && props.row.payload.taskContext && typeof props.row.payload.taskContext === 'object'">
                                            <zm-form-item v-for="item in Object.keys(props.row.payload.taskContext)" :key="item" :label="item">
                                                <span>{{ props.row.payload.taskContext[item] }}</span>
                                                <span v-if="item === 'produceTime' || item === 'generateTime'">
                                                    ({{ setTime('', '', props.row.payload.taskContext[item]) }})
                                                </span>
                                            </zm-form-item>
                                        </zm-form>
                                        <span v-else-if="props.row.payload">{{ props.row.payload.taskContext }}</span>
                                    </zm-form-item>
                                </zm-form>
                                <!-- <zm-tag size="medium" v-if="!props.row.payload && props.row.payload !== ''" type="warning">hidden</zm-tag>
                                <span v-else>{{ props.row.payload }}</span> -->
                            <!-- </zm-form-item> -->
                        </zm-form>
                    </template>
                </zm-table-column>
                <zm-table-column prop="name" label="name" align="center" :show-overflow-tooltip="true">
                </zm-table-column>
                <zm-table-column prop="taskStatus" label="status" align="center">
                </zm-table-column>
                <zm-table-column prop="taskId" label="taskId" align="center">
                    <template slot-scope="scope">
                        <zm-button type="link" @click="clickSearch(scope.row.taskId)">{{scope.row.taskId}}</zm-button>
                    </template>
                </zm-table-column>
                <zm-table-column prop="generateTime" label="generateTime" align="center" :formatter="setTime" :show-overflow-tooltip="true" v-if="!showGroupColumn">
                </zm-table-column>
                <zm-table-column prop="modifiedTime" label="modifiedTime" align="center" :formatter="setTime" :show-overflow-tooltip="true">
                </zm-table-column>
                <zm-table-column label="operate" width="190px" align="center" v-if="hasPermission">
                    <template slot-scope="scope">
                        <zm-button class="btn-contain" type="icon" title="trigger task" icon="zm-icon-play-circle-outline" @click="triggerTask(scope.row, 'parentLoading')"
                        v-show="scope.row.taskStatus !== 'RECEIVED'"></zm-button>
                        <zm-button class="btn-contain" type="icon" title="delete task" icon="zm-icon-delete" @click="deleteTask(scope.row.id, scope.row.taskStatus, 'parentLoading')"></zm-button>
                    </template>
                </zm-table-column>
            </zm-table>
            <div class="taskTitle" v-if="showParent">
                <p>Report Tasks</p>
            </div>
            <zm-table resizable border :data="list" v-loading="loading" @expand-change="expandHandler" :stripe="true" @sort-change="onSort">
                <zm-table-column type="expand">
                    <template slot-scope="props">
                        <zm-form label-position="left" inline class="demo-table-expand">
                            <!-- <zm-form-item label="id">
                                <span>{{ props.row.id }}</span>
                            </zm-form-item> -->
                            <zm-form-item label="taskId">
                                <span>{{ props.row.taskId }}</span>
                            </zm-form-item>
                            <zm-form-item label="originalTaskId" v-show="props.row.taskStatus === 'PRODUCED' || props.row.taskStatus === 'PRODUCE_FAILED' || props.row.taskStatus === 'REPRODUCED'">
                                <zm-button type="link" @click="doSearchOriginal(props.row.originalTaskId)" v-if="props.row.originalTaskId">{{props.row.originalTaskId}}</zm-button>
                                <span v-else>null</span>
                            </zm-form-item>
                            <zm-form-item label="generateTime" v-if="props.row.taskStatus === 'PRODUCED' || props.row.taskStatus === 'PRODUCE_FAILED' || props.row.taskStatus === 'REPRODUCED'">
                                <span>{{ setTime('', '', props.row.generateTime) || 'null' }}</span>
                            </zm-form-item>
                            <zm-form-item label="group" v-if="props.row.taskStatus !== 'PRODUCED' && props.row.taskStatus !== 'PRODUCE_FAILED' && props.row.taskStatus !== 'REPRODUCED'">
                                <span>{{ props.row.group || 'null' }}</span>
                            </zm-form-item>
                            <zm-form-item label="consumeCost" v-if="props.row.taskStatus !== 'PRODUCED' && props.row.taskStatus !== 'PRODUCE_FAILED' && props.row.taskStatus !== 'REPRODUCED'">
                                <span>{{ props.row.consumeCost }}</span>
                            </zm-form-item>
                            <zm-form-item label="clientInfo">
                                <span>{{ props.row.clientInfo || 'null' }}</span>
                            </zm-form-item>
                            <zm-form-item label="subscriber" v-if="props.row.subscriber">
                                <span>{{ props.row.subscriber }}<b>({{ props.row.subscriberName }})</b></span>
                                <!-- <span v-else>null</span> -->
                            </zm-form-item>
                            <zm-form-item label="publisher" v-if="props.row.publisher">
                                <span>{{ props.row.publisher }}<b>({{ props.row.publisherName }})</b></span>
                                <!-- <span v-else>null</span> -->
                            </zm-form-item>
                            <zm-form-item label="topicId">
                                <span>
                                    <a @click="jumpToTopic(props.row.topicId)">{{ props.row.topicId }}</a>
                                    <a v-if="props.row.topicName">
                                        <zm-popover placement="bottom" width="500" trigger="click" popper-class="topic-detail-popover">
                                            <div>
                                                <span v-for="( value, key ) in props.row.topic" :key="key">
                                                    <p v-if="!/advancedFeatureMap|publishers|subscribers|createdTime|modifiedTime|name|id|currentRegion|owner|ttlDuration|ttlDurationTimeUnit/.test(key)">{{ key }}:{{ value }}</p>
                                                </span>
                                            </div>
                                            <b slot="reference">({{ props.row.topicName }})</b>
                                        </zm-popover>
                                    </a>
                                </span>
                            </zm-form-item>
                            <zm-form-item label="taskType">
                                <span>{{ props.row.taskType }}</span>
                            </zm-form-item>
                            <zm-form-item label="retryTimes" v-if="props.row.taskStatus !== 'PRODUCED'">
                                <span>{{ props.row.retryTimes }}</span>
                            </zm-form-item>
                            <zm-form-item label="metaData" v-if="props.row.taskStatus !== 'PRODUCED' && props.row.taskStatus !== 'PRODUCE_FAILED' && props.row.taskStatus !== 'REPRODUCED'">
                                <span>{{ props.row.metaData }}</span>
                            </zm-form-item>
                            <zm-form-item label="reports">
                                <div v-if="props.row.reports">
                                    <div v-for="item of props.row.reports" :key="item"><span>{{item}}</span></div>
                                </div>
                                <span v-else>null</span>
                            </zm-form-item>
                            <!-- <zm-form-item label="body" label-width="0"> -->
                                <zm-form class="form-inside" label-width="100px">
                                    <zm-form-item label="payload">
                                        <zm-tag size="medium" v-if="props.row.hiddenEnable" type="warning">hidden</zm-tag>
                                        <zm-form class="body-table-expand"
                                        v-else-if="props.row.payload && props.row.payload.payload && typeof props.row.payload.payload === 'object'">
                                            <zm-form-item v-for="item in Object.keys(props.row.payload.payload)" :key="item" :label="item">
                                                <span>{{ props.row.payload.payload[item] }}</span>
                                                <span v-if="item === 'timestamp'">({{ setTime('', '', props.row.payload.payload[item]) }})</span>
                                            </zm-form-item>
                                        </zm-form>
                                        <span v-else-if="props.row.payload">{{ props.row.payload.payload }}</span>
                                    </zm-form-item>
                                    <zm-form-item label="metadata">
                                        <zm-form class="body-table-expand"
                                        v-if="props.row.payload && props.row.payload.metadata && typeof props.row.payload.metadata === 'object'">
                                            <zm-form-item v-for="item in Object.keys(props.row.payload.metadata)" :key="item" :label="item">
                                                <span>{{ props.row.payload.metadata[item] }}</span>
                                                <span v-if="item === 'messageTimestamp'">({{ setTime('', '', props.row.payload.metadata[item]) }})</span>
                                            </zm-form-item>
                                        </zm-form>
                                        <span v-else-if="props.row.payload">{{ props.row.payload.metadata }}</span>
                                    </zm-form-item>
                                    <zm-form-item label="taskContext">
                                        <zm-form class="body-table-expand"
                                        v-if="props.row.payload && props.row.payload.taskContext && typeof props.row.payload.taskContext === 'object'">
                                            <zm-form-item v-for="item in Object.keys(props.row.payload.taskContext)" :key="item" :label="item">
                                                <span>{{ props.row.payload.taskContext[item] }}</span>
                                                <span v-if="item === 'produceTime' || item === 'generateTime'">
                                                    ({{ setTime('', '', props.row.payload.taskContext[item]) }})
                                                </span>
                                            </zm-form-item>
                                        </zm-form>
                                        <span v-else-if="props.row.payload">{{ props.row.payload.taskContext }}</span>
                                    </zm-form-item>
                                </zm-form>
                            <!-- </zm-form-item> -->
                        </zm-form>
                    </template>
                </zm-table-column>
                <zm-table-column prop="name" label="name" align="center" :show-overflow-tooltip="true">
                </zm-table-column>
                <zm-table-column prop="group" label="group" align="center" :show-overflow-tooltip="true" v-if="showGroupColumn || showParent" sortable>
                </zm-table-column>
                <zm-table-column prop="taskStatus" label="status" align="center">
                </zm-table-column>
                <zm-table-column prop="taskId" label="taskId" align="center">
                    <template slot-scope="scope">
                        <zm-button type="link" @click="clickSearch(scope.row.taskId)">{{scope.row.taskId}}</zm-button>
                    </template>
                </zm-table-column>
                <zm-table-column prop="generateTime" label="generateTime" align="center" :formatter="setTime" :show-overflow-tooltip="true" v-if="!showGroupColumn">
                </zm-table-column>
                <zm-table-column prop="modifiedTime" label="modifiedTime" align="center" :formatter="setTime" :show-overflow-tooltip="true">
                </zm-table-column>
                <zm-table-column width="120px" align="center" v-if="hasPermission">
                    <template slot-scope="scope">
                        <zm-button class="btn-contain" type="icon" title="trigger task" icon="zm-icon-play-circle-outline" @click="triggerTask(scope.row, 'loading')"
                        v-show="scope.row.taskStatus !== 'RECEIVED'"></zm-button>
                        <zm-button class="btn-contain" type="icon" title="delete task" icon="zm-icon-delete" @click="deleteTask(scope.row.id, scope.row.taskStatus, 'loading')"></zm-button>
                    </template>
                </zm-table-column>
            </zm-table>
            <div style="text-align: center" class="pagination-wrap">
                <zm-pagination @current-change="paginationChange"
                    @size-change="handleSizeChange"
                    :current-page.sync="pageable.page" :page-size="pageable.size"
                    :page-sizes="[10, 20, 50, 100, 500, 1000]"
                    layout="sizes, total, prev, pager, next, jumper"
                    :total="pageable.total">
                </zm-pagination>
            </div>
        </div>
        <zm-dialog :visible.sync="triggerVisible" title="Batch Trigger" :show-close="true">
            <zm-form :model="filter" :rules="rules" ref="form" label-width="130px" label-position="left">
                <zm-form-item label="topic" prop="topicId">
                    <div slot="label">
                        <tip label="topic" id="task-trigger-topic"></tip>
                    </div>
                    <zm-select size="small" v-model="filter.topicId" clearable filterable disabled>
                        <zm-option v-for="item in topicList" :key="item.id" :value="item.id" :label="item.name"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item label="taskType" prop="taskType">
                    <div slot="label">
                        <tip label="taskType" id="task-trigger-taskType"></tip>
                    </div>
                    <zm-select size="small" v-model="filter.taskType" clearable filterable disabled>
                        <zm-option v-for="item in subtopics" :key="item" :value="item" :label="item"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item label="triggerId" prop="triggerId">
                    <div slot="label">
                        <tip label="triggerId" id="task-trigger-triggerId"></tip>
                    </div>
                    <zm-popover
                        placement="top"
                        trigger="focus"
                        :content="filter.topicName">
                        <zm-input size="small" v-model.trim="filter.topicName" style="width: 25%" slot="reference"></zm-input>
                    </zm-popover>
                    <zm-input size="small" readonly v-model="filter.date" style="width: 20%"></zm-input>_
                    <zm-input size="small" v-model.trim="filter.triggerId" style="width: 45%"></zm-input>
                </zm-form-item>
                <zm-form-item label="maxRetryTimes" prop="maxRetryTimes">
                    <div slot="label">
                        <tip label="maxRetryTimes" id="task-trigger-maxRetryTimes"></tip>
                    </div>
                    <zm-input-number size="small" v-model="filter.maxRetryTimes" :min="0"></zm-input-number>
                </zm-form-item>
                <zm-form-item label="name">
                    <div slot="label">
                        <tip label="name" id="task-trigger-name"></tip>
                    </div>
                    <zm-input size="small" v-model.trim="filter.name" disabled></zm-input>
                </zm-form-item>
                <zm-form-item label="keyword">
                    <div slot="label">
                        <tip label="keyword" id="task-trigger-keyword"></tip>
                    </div>
                    <zm-input size="small" v-model.trim="filter.keyword" disabled></zm-input>
                </zm-form-item>
                <zm-form-item label="group">
                    <div slot="label">
                        <tip label="group" id="task-trigger-group"></tip>
                    </div>
                    <zm-input size="small" v-model.trim="filter.group" disabled></zm-input>
                </zm-form-item>
                <zm-form-item label="time">
                    <div slot="label">
                        <tip label="time" id="task-trigger-time"></tip>
                    </div>
                   <zm-date-picker size="small" disabled
                        v-model="filter.daterange"
                        type="datetimerange"
                        range-separator="to"
                        clear-icon="zm-icon-error"
                        value-format="timestamp"></zm-date-picker>
                </zm-form-item>
                <zm-form-item label="status">
                    <div slot="label">
                        <tip label="status" id="task-trigger-status"></tip>
                    </div>
                    <zm-select size="small" v-model="filter.status" disabled>
                        <zm-option value="FAILED" label="FAILED"></zm-option>
                        <zm-option value="FINAL_FAILED" label="FINAL_FAILED"></zm-option>
                        <zm-option value="PRODUCE_FAILED" label="PRODUCE_FAILED"></zm-option>
                    </zm-select>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button @click="triggerVisible = false">Cancel</zm-button>
                <zm-button type="primary" @click="batchTrigger()" :loading="loading">Batch Trigger</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Create Tasks" :visible.sync="uploadVisible">
            <zm-form label-position="left" label-width="150px">
                <zm-form-item label="Upload Limit Count">
                    <div slot="label">
                        <tip label="Upload Limit Count" id="task-upload-uploadLimitCount"></tip>
                    </div>
                    <zm-input-number size="small" v-model="uploadLimitCount" :min="1" :max="100"></zm-input-number>
                </zm-form-item>
                <zm-form-item label="Upload Demo">
                    <div slot="label">
                        <tip label="Upload Demo" id="task-upload-demo"></tip>
                    </div>
                    <template slot="label">
                        <zm-button size="small" type="icon" icon="zm-icon-download" @click="downloadTemplate"></zm-button>
                    </template>
                    <div v-for="(item, index) in template.split('\n')" :key="index" style="font-size: 10px;line-height: 1.6em;">{{ item }}</div>
                </zm-form-item>
                <zm-form-item label-width="0" align="center">
                    <zm-upload
                        drag
                        ref="upload"
                        action=""
                        id="secret-upload"
                        :http-request="myUpload"
                        :on-change="fileChange"
                        :on-remove="fileRemove"
                        :auto-upload="false"
                        :file-list="fileList">
                        <i class="zm-icon-upload"></i>
                        <div class="zm-upload__text">Drop file here or <em>click to upload</em></div>
                        <!-- <zm-button size="small" plain class="btn-right" type="primary" v-loading="loading">Import</zm-button> -->
                    </zm-upload>
                </zm-form-item>
                <zm-progress v-if="uploading" :percentage="!uploadData.length ? 0 : (uploadingIndex * uploadLimitCount * 100 / uploadData.length).toFixes(2)"></zm-progress>
                <zm-progress v-if="!uploading && uploadData.length && uploadData[uploadData.length - 1].result" :percentage="100" status="success"></zm-progress>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="closeUpload">Cancel</zm-button>
                <zm-button size="small" style="margin-left: 10px;" @click="downloadResponse" type="primary" v-if="!uploading && uploadData.length && uploadData[uploadData.length - 1].result">Download Response</zm-button>
                <zm-button size="small" style="margin-left: 10px;" type="primary" @click="showConfirmUpload = true" :loading="uploading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Confirm Create" :visible.sync="showConfirmUpload">
            <div v-if="uploadErrorMsg.invalidParam">Lines {{ uploadErrorMsg.invalidParam }} do not have topicName or taskType.</div>
            <div v-if="uploadErrorMsg.notJson">Lines {{ uploadErrorMsg.notJson }} are not json.</div>
            <zm-table :data="totalTopic">
                <zm-table-column label="topic" prop="topicName"></zm-table-column>
                <zm-table-column label="sub topic" prop="taskType"></zm-table-column>
                <zm-table-column label="total" prop="total"></zm-table-column>
            </zm-table>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="showConfirmUpload = false">Cancel</zm-button>
                <zm-button size="small" style="margin-left: 10px;" type="primary" @click="myUpload(0)"
                v-if="!uploadErrorMsg.invalidParam && !uploadErrorMsg.notJson">Submit</zm-button>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import { getTaskList, deleteTaskList, deleteTask, getTaskListById,
getTaskListByParentId, triggerTopicTask, getUserListById,
getTopics,
getTaskGroups, getTaskSubtopics,
getTopicTasksByOriginalTaskId,
createTask,
getTopicById } from '../../api/index'
import { batchTrigger } from '../../api/trigger'
import TimePickerOption from '@/components/TimeRangePicker/index'
import template from './template.js'
import tip from 'components/ToolTip/index'
export default {
    name: 'task',
    components: {
        tip,
        TimePickerOption
    },
    data () {
        var validateTriggerId = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('please enter triggerId'))
            } else {
                var reg = /^[^\s]*$/
                if (reg.test(value) && value.length <= 64) {
                    callback()
                }
                callback(new Error('invalid triggerId!'))
            }
        }
        return {
            hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            select: 'id',
            showGroupColumn: false,
            list: [],
            groups: [],
            subtopics: [],
            showParent: false,
            parentList: [],
            topicList: [],
            loadingTopic: false,
            listBy: 0,
            // isSearch: true,
            loading: false,
            parentLoading: false,
            pageable: {
                page: 1,
                size: 10,
                total: 0
            },
            template: template.template,
            fileList: [],
            fileName: '',
            uploadVisible: false,
            uploadLimitCount: 10,
            uploadingCount: 0,
            uploadingIndex: 0,
            uploading: false,
            uploadData: [],
            totalTopic: [],
            uploadErrorMsg: {
                notJson: '',
                invalidParam: ''
            },
            showConfirmUpload: false,
            filter: {
                name: '',
                keyword: '',
                minConsumeCost: undefined,
                maxConsumeCost: undefined,
                group: '',
                topicId: '',
                taskType: '',
                daterange: [],
                from: '',
                to: '',
                topicName: '',
                date: '',
                triggerId: '',
                maxRetryTimes: 3,
                status: 'PRODUCED'
            },
            triggerVisible: false,
            rules: {
                topicId: [
                    { required: true, message: 'please choose a topic', trigger: 'blur' }
                ],
                triggerId: [
                    { required: true, validator: validateTriggerId, trigger: 'blur' }
                ],
                maxRetryTimes: [
                    { required: true, message: 'please enter maxRetryTimes', trigger: 'blur' }
                ]
            },
            search: '',
            searchStatus: '',
            timeZone: 0,
            showTimeZone: 0,
            statusList: [
                'SUCCESS', 'FAILED', 'FINAL_FAILED', 'RECEIVED', 'DISCARDED', 'FILTERED', 'PRODUCED', 'PRODUCE_FAILED', 'REPRODUCED', 'NO_HANDLER_DISCARD', 'RECEIVE_NO_HANDLE', 'RECEIVE_SHAKE', 'RETRY_NO_FAILED'
            ]
        }
    },
    created () {
        this.fetchTopics()
        this.fetchGroups()
        if (localStorage.params && localStorage.params !== 'undefined' && localStorage.path === this.$route.path) {
            this.select = JSON.parse(localStorage.params).select
            this.search = JSON.parse(localStorage.params).search
            this.filter = JSON.parse(localStorage.params).filter
            this.listBy = JSON.parse(localStorage.params).listBy
            this.pageable.page = JSON.parse(localStorage.params).page
            this.pageable.size = JSON.parse(localStorage.params).size
            if (this.filter.from) {
                this.$nextTick(() => {
                    this.$refs.timePickerOption.startTs = this.filter.from
                })
            }
            if (this.filter.to) {
                this.$nextTick(() => {
                    this.$refs.timePickerOption.endTs = this.filter.to
                })
            }
            if (this.listBy) {
                this.doSearch()
            } else {
                this.fetchData()
            }
        } else if (this.$route.query.id) {
            this.search = this.$route.query.id
            this.doSearch()
        } else {
            this.fetchData()
        }
        localStorage.params = ''
        localStorage.path = this.$route.path
        this.timeZone = -(new Date()).getTimezoneOffset() / 60
        this.showTimeZone = this.timeZone
    },
    watch: {
        uploadingCount () {
            if (!this.uploadingCount) {
                this.uploadingIndex++
                this.myUpload()
            }
        },
        select () {
            this.setURL()
        },
        search () {
            this.setURL()
        },
        listBy () {
            this.setURL()
        },
        'pageable.page' () {
            this.setURL()
        },
        'pageable.size' () {
            this.setURL()
        },
        'filter.name' () {
            this.setURL()
        },
        'filter.keyword' () {
            this.setURL()
        },
        'filter.minConsumeCost' () {
            this.setURL()
        },
        'filter.maxConsumeCost' () {
            this.setURL()
        },
        'filter.group' () {
            this.setURL()
        },
        'filter.topicId' () {
            this.setURL()
        },
        'filter.taskType' () {
            this.setURL()
        },
        'filter.from' () {
            this.setURL()
        },
        'filter.to' () {
            this.setURL()
        },
        'filter.daterange' () {
            this.setURL()
        },
        'filter.status' () {
            this.setURL()
        }
    },
    beforeRouteLeave (to, from, next) {
        if (this.uploading) {
            this.$confirm('Leaving this page will interrupt creating tasks. Continue?', 'Warning', {
                confirmButtonText: 'Continue',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                next()
            }).catch(() => {
                this.next(false)
            })
        } else {
            next()
        }
    },
    methods: {
        setURL () {
            const { select, search, filter, listBy } = this
            const { page, size } = this.pageable
            const data = { path: this.$route.path, select, search, filter, listBy, page, size }
            localStorage.params = JSON.stringify(data)
        },
        showUpload () {
            this.uploadVisible = true
            this.uploadingCount = 0
            this.uploadingIndex = 0
            this.uploadData = []
        },
        closeUpload () {
            if (this.uploading || (this.uploadData.length && this.uploadData[this.uploadData.length - 1].result)) {
                this.$confirm('Responses will be unable to be downloaded after closing the dialog. Continue?', 'Warning', {
                    confirmButtonText: 'Close',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.$refs.upload.clearFiles()
                    this.uploadVisible = false
                })
            } else {
                this.$refs.upload.clearFiles()
                this.uploadVisible = false
            }
        },
        fileChange (file, fileList) {
            if (fileList.length > 1) {
                this.$refs.upload.uploadFiles = [fileList[1]]
            }
            this.uploadingCount = 0
            this.uploadingIndex = 0
            this.uploadData = []
            this.fileName = file.name
            let reader = new FileReader()
            var that = this
            if (file.raw) {
                reader.readAsText(file.raw, 'gb2312')
                reader.onload = function (e) {
                    that.uploadErrorMsg.notJson = ''
                    that.uploadErrorMsg.invalidParam = ''
                    that.totalTopic = []
                    that.uploadData = e.target.result.split('\n').map((item, index) => {
                        try {
                            if (item) {
                                if (JSON.parse(item).topicName && JSON.parse(item).taskType) {
                                    var hasTopic = false
                                    that.totalTopic.map(e => {
                                        if (e.topicName === JSON.parse(item).topicName &&
                                        e.taskType === JSON.parse(item).taskType) {
                                            e.total++
                                            hasTopic = true
                                        }
                                    })
                                    if (!hasTopic) {
                                        that.totalTopic.push({
                                            topicName: JSON.parse(item).topicName,
                                            taskType: JSON.parse(item).taskType,
                                            total: 1
                                        })
                                    }
                                } else {
                                    that.uploadErrorMsg.invalidParam += that.uploadErrorMsg.invalidParam ? ', ' + (index + 1) : (index + 1)
                                }
                            }
                        } catch {
                            that.uploadErrorMsg.notJson += that.uploadErrorMsg.notJson ? ', ' + (index + 1) : (index + 1)
                        }
                        return {
                            data: item,
                            result: ''
                        }
                    })
                    that.uploadData = that.uploadData.filter(item => {
                        return item.data.length > 0
                    })
                    if (that.uploadErrorMsg.notJson || that.uploadErrorMsg.invalidParam) {
                        that.showConfirmUpload = true
                    }
                }
            }
        },
        fileRemove () {
            this.uploadData = []
        },
        submitUpload () {
            this.$refs.upload.submit()
        },
        async myUpload () {
            this.showConfirmUpload = false
            if (this.uploadData.length) {
                if (this.uploadingIndex < this.uploadData.length / this.uploadLimitCount) {
                // for (let i = 0; i < this.uploadData.length / this.uploadLimitCount; i++) {
                    if (!this.uploadingIndex) {
                        this.$message.info('Creating tasks, please do not leave the page.')
                    }
                    this.uploading = true
                    var that = this
                    // if (!this.uploadingCount) {
                        new Promise(
                            function () {
                                that.createTasks(that.uploadingIndex)
                            }
                        ).then(res => {
                            this.uploadingIndex++
                            that.myUpload()
                        })
                    // }
                } else {
                    this.$message.success('Requests have been excuted. You can download responses.')
                    this.uploadingCount = 0
                    this.uploadingIndex = 0
                    this.uploading = false
                }
            }
        },
        async createTasks (i) {
            for (let j = 0; j < this.uploadLimitCount; j++) {
                if (i * this.uploadLimitCount + j < this.uploadData.length) {
                    this.uploadingCount++
                    createTask(this.uploadData[i * this.uploadLimitCount + j].data).then(response => {
                        this.uploadingCount--
                        this.uploadData[i * this.uploadLimitCount + j].result = JSON.stringify(response)
                    }).catch(() => {
                        this.uploadingCount--
                    })
                }
            }
        },
        handleCommand (command) {
            if (command === 'downloadTemplate') {
                this.downloadTemplate()
            }
        },
        downloadTemplate () {
            var pom = document.createElement('a')
            pom.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(this.template))
            pom.setAttribute('download', 'template.txt')
            if (document.createEvent) {
                var event = document.createEvent('MouseEvents')
                event.initEvent('click', true, true)
                pom.dispatchEvent(event)
            } else {
                pom.click()
            }
        },
        downloadResponse () {
            var pom = document.createElement('a')
            var text = ''
            this.uploadData.map(item => {
                text += item.data + '    ' + item.result + '\n'
            })
            pom.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text))
            pom.setAttribute('download', this.fileName)
            if (document.createEvent) {
                var event = document.createEvent('MouseEvents')
                event.initEvent('click', true, true)
                pom.dispatchEvent(event)
            } else {
                pom.click()
            }
        },
        setTimeRange (val, timeZone) {
            this.timeZone = timeZone
            this.filter.daterange[0] = val[0]
            this.filter.daterange[1] = val[1]
        },
        jumpToTopic (id) {
            this.$router.push({
                path: '/dashboard/topic/',
                query: { id }
            })
        },
        onSort ({ column, prop, order }) {
            const descending = order === 'descending'
            this.list.sort((a, b) => {
            if (a[prop] > b[prop]) {
                return descending ? -1 : 1
            } else if (a[prop] < b[prop]) {
                return descending ? 1 : -1
            } else {
                return 0
            }
            })
        },
        setTime (row, column, cellValue, index) {
            const time = parseInt(cellValue) + this.timeZone * 60 * 60 * 1000
            return new Date(time).getUTCFullYear() + '-' + (new Date(time).getUTCMonth() + 1) + '-' + new Date(time).getUTCDate() + ' ' + new Date(time).getUTCHours() + ':' + new Date(time).getUTCMinutes() + ':' + new Date(time).getUTCSeconds()
            // return new Date(parseInt(time)).toUTCString()
            // return val.createdTime.split('T')[0] + ' ' + val.createdTime.split('T')[1].split('.')[0]
        },
        async expandHandler (row, expandedRows) {
            expandedRows.forEach(e => {
                if (row.id === e.id) {
                    getTaskListById(row.id).then(response => {
                        row.reports = response.task.reports
                        row.payload = response.task.payload
                        row.hiddenEnable = response.task.hiddenEnable
                        if (!response.task.payload && response.task.payload !== '') {
                            row.payload = null
                        }
                    })
                    // get topic name
                    getTopicById(row.topicId).then(response => {
                        row.topicName = response.name
                        row.topic = response
                    })
                    // get  subscriber name
                    if (row.subscriber) {
                        getUserListById(row.subscriber).then(response => {
                            row.subscriberName = response.name
                        })
                    }
                    if (row.publisher) {
                        getUserListById(row.publisher).then(response => {
                            row.publisherName = response.name
                        })
                    }
                }
            })
        },
        async expandParentHandler (row, expandedRows) {
            expandedRows.forEach(e => {
                if (row.id === e.id) {
                    getTaskListById(row.id).then(response => {
                        row.reports = response.task.reports
                        row.payload = response.task.payload
                        row.hiddenEnable = response.task.hiddenEnable
                    })
                    // get topic name
                    getTopicById(row.topicId).then(response => {
                        row.topicName = response.name
                        row.topic = response
                    })
                    // get  subscriber name
                    if (row.subscriber) {
                        getUserListById(row.subscriber).then(response => {
                            row.subscriberName = response.name
                        })
                    }
                    if (row.publisher) {
                        getUserListById(row.publisher).then(response => {
                            row.publisherName = response.name
                        })
                    }
                }
            })
        },
        searchByFilter () {
            this.listBy = 0
            this.fetchData()
        },
        fetchTopics () {
            this.loadingTopic = true
            getTopics().then(response => {
                this.topicList = response
                this.loadingTopic = false
            }).catch(() => {
                this.loadingTopic = false
            })
        },
        refreshLists () {
            if (this.filter.topicId) {
                this.topicList.map(item => {
                    if (item.id === this.filter.topicId) {
                        this.filter.topicName = item.name
                    }
                })
            }
            this.fetchSubtopic()
            this.fetchGroups()
        },
        fetchSubtopic () {
            this.filter.taskType = ''
            getTaskSubtopics(this.filter.topicId).then(response => {
                this.subtopics = response
            })
        },
        fetchGroups () {
            this.filter.group = ''
            getTaskGroups(this.filter.topicId).then(response => {
                this.groups = response
            })
        },
        fetchData () {
            this.loading = true
            this.showParent = false
            let keyword = this.filter.keyword
            if (this.filter.daterange) {
                this.filter.from = this.filter.daterange[0]
                this.filter.to = this.filter.daterange[1]
            } else {
                this.filter.to = ''
                this.filter.from = ''
            }
            if (this.filter.status !== 'PRODUCED' && this.filter.status === 'PRODUCE_FAILED' && this.filter.status === 'REPRODUCED') {
                keyword = ''
            }
            getTaskList(this.filter.name, keyword, this.filter.minConsumeCost, this.filter.maxConsumeCost, this.filter.group, this.filter.topicId, this.filter.taskType, this.filter.from, this.filter.to, this.filter.status, this.pageable.size, this.pageable.page - 1).then(response => {
                this.showTimeZone = this.timeZone
                const { content, pageable: { page, size }, total } = response
                content.forEach(e => {
                    e.subscriberName = ''
                    e.topicName = ''
                    e.payload = ''
                })
                if (this.filter.status !== 'PRODUCED' && this.filter.status === 'PRODUCE_FAILED' && this.filter.status === 'REPRODUCED') {
                    this.showGroupColumn = true
                } else {
                    this.showGroupColumn = false
                }
                this.list = content
                this.pageable.total = total
                this.pageable.page = page + 1
                this.pageable.size = size
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        changeSearchType () {
            this.search = ''
        },
        clickSearch (id) {
            if (id) {
                this.select = 'id'
            this.search = id
            }
            this.pageable.page = 1
            // this.isSearch = false
            if (this.select === 'id') {
                this.doSearch()
            } else {
                this.doSearchOriginal()
            }
        },
        doSearchOriginal (val) {
            this.loading = true
            this.showParent = false
            if (val) {
                this.search = val
                this.select = 'original'
            }
            if (this.search === '') {
                this.loading = false
                this.$message({
                    message: 'Please input value to search!',
                    type: 'warning'
                })
            } else {
                this.listBy = 1
                getTopicTasksByOriginalTaskId(this.search, this.pageable.size, this.pageable.page - 1).then(response => {
                    const { content, pageable: { page, size }, total } = response
                    content.forEach(e => {
                        e.subscriberName = ''
                        e.topicName = ''
                        e.payload = ''
                    })
                    this.showGroupColumn = false
                    this.list = content
                    this.pageable.total = total
                    this.pageable.page = page + 1
                    this.pageable.size = size
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            }
        },
        doSearch () {
            this.loading = true
            this.showParent = false
            if (this.search === '') {
                this.loading = false
                this.$message({
                    message: 'Please input value to search!',
                    type: 'warning'
                })
            } else {
                this.listBy = 1
                getTaskListByParentId(this.search, this.pageable.size, this.pageable.page - 1).then(response => {
                    this.showTimeZone = this.timeZone
                    const { content, pageable: { page, size }, total } = response
                    content.forEach(e => {
                        e.subscriberName = ''
                        e.topicName = ''
                    })
                    this.list = content
                    this.pageable.total = total
                    this.pageable.page = page + 1
                    this.pageable.size = size
                    this.showParent = true
                    getTaskListById(this.search).then(res => {
                        const { task } = res
                        this.parentList = []
                        if (task) {
                            task.subscriberName = ''
                            task.topicName = ''
                            this.parentList.push(task)
                        }
                        this.loading = false
                    })
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            }
        },
        handleSizeChange (value) {
            this.pageable.size = value
            if (this.listBy) {
                if (this.select === 'id') {
                    this.doSearch()
                } else {
                    this.doSearchOriginal()
                }
            } else {
                this.fetchData()
            }
        },
        paginationChange () {
            if (this.listBy) {
                if (this.select === 'id') {
                    this.doSearch()
                } else {
                    this.doSearchOriginal()
                }
            } else {
                this.fetchData()
            }
        },
        // showSearch () {
        //     this.isSearch = true
        // },
        deleteTasks () {
            this.$confirm('This will permanently delete the tasks. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                // this.filter.from = this.filter.daterange[0].split('T')[0]
                // this.filter.to = this.filter.daterange[1].split('T')[0]
                deleteTaskList(this.filter.name, this.filter.group, this.filter.minConsumeCost, this.filter.maxConsumeCost, this.filter.topicId, this.filter.taskType, this.filter.from, this.filter.to, this.filter.status, this.pageable.size, this.pageable.page - 1).then(response => {
                    this.loading = false
                    this.fetchData()
                    this.$message({
                        message: 'Submit delete success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        },
        deleteTask (id, status, loading) {
            this.$confirm('This will permanently delete the task. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this[loading] = true
                deleteTask(id, status).then(response => {
                    this[loading] = false
                    this.fetchData()
                    this.$message({
                        message: 'Delete task success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this[loading] = false
                })
            }).catch(() => {
                this[loading] = false
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        },
        showTriggerTasks () {
            if (this.filter.topicId) {
                var month = new Date().getMonth() + 1
                month = month < 10 ? '0' + month : month + ''
                var date = new Date().getDate()
                date = date < 10 ? '0' + date : date + ''
                this.filter.date = new Date().getFullYear().toString() + month + date
                this.triggerVisible = true
            } else {
                this.$message({
                    message: 'please select a topic before batch trigger',
                    type: 'warning'
                })
            }
        },
        batchTrigger () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.$confirm('This will trigger the tasks. Continue?', 'Warning', {
                        confirmButtonText: 'Continue',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                    }).then(() => {
                        this.loading = true
                        if (this.filter.daterange) {
                            this.filter.from = this.filter.daterange[0]
                            this.filter.to = this.filter.daterange[1]
                        } else {
                            this.filter.to = ''
                            this.filter.from = ''
                        }
                        const { name,
                            keyword,
                            group,
                            topicId,
                            taskType,
                            from,
                            to,
                            maxRetryTimes,
                            status } = this.filter
                        const triggerId = this.filter.topicName + '_' + this.filter.date + '_' + this.filter.triggerId
                        const data = { name, keyword, group, topicId, taskType, triggerId, maxRetryTimes, from, to, status }
                        batchTrigger(data).then(response => {
                            this.triggerVisible = false
                            this.$message({
                                message: 'Batch trigger success!',
                                type: 'success'
                            })
                            this.loading = false
                            this.$router.push('/dashboard/trigger')
                        }).catch(() => {
                            this.loading = false
                        })
                    }).catch(() => {
                        this.loading = false
                        this.$message({
                            type: 'info',
                            message: 'Trigger canceled'
                        })
                    })
                } else {
                    this.$message({
                        message: 'invalid submit',
                        type: 'error'
                    })
                }
            })
        },
        triggerTask (row, loading) {
            this.$confirm('This will trigger the task. Continue?', 'Warning', {
                confirmButtonText: 'Trigger',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this[loading] = true
                triggerTopicTask(row.id, row.taskStatus).then(response => {
                    this[loading] = false
                    this.fetchData()
                    this.$message({
                        message: 'Trigger task success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this[loading] = false
                })
            }).catch(() => {
                this[loading] = false
                this.$message({
                    type: 'info',
                    message: 'Trigger canceled'
                })
            })
        }
    }
}
</script>
<style>
.task-select {
    float: right;
    width: 130px;
}
.task-inline-select {
    width: calc((100vw - 500px) / 3);
    /* width: 140px; */
}
.task-input{
    float: right;
    margin: 0 10px;
}
</style>
<style>
.zm-form--inline .zm-form-item {
    margin-top: 5px;
    margin-bottom: 5px;
    vertical-align: baseline;
}
.zm-form--inline .zm-form-item__content {
    line-height: 32px;
}
.zm-input-group__prepend {
    font-size: 12px;
}
.date-in-line{
    width: 150px;
    margin: 10px;
}
.inline-number.zm-input-number {
    width: 170px;
    /* margin: 10px 5px; */
}
.task-status-select{
    width: 130px;
    /* margin: 10px 5px; */
}
.task-input-in-line{
    /* margin: 10px 5px; */
    width: calc((100vw - 500px) / 5);
    /* width: 140px; */
}
.btn-in-line{
    margin: 10px;
}
.btn-in-line-right {
    float: right;
    margin: 10px;
}
.input-with-select{
    float: right;
    margin: 10px;
    width: 250px;
}
.search-status {
    float: right;
}
.index-select {
    width: 110px;
}
.demo-table-expand {
    font-size: 0;
}
.demo-table-expand label {
    width: 105px;
    color: #99a9bf;
}
.body-table-expand label {
    width: 180px;
    color: #99a9bf;
}
.demo-table-expand .zm-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
}
.topic-detail-popover {
  height: 300px;
  overflow: auto;
}
.taskTitle {
    text-align: center;
    color: #0E71EB;
}
.zm-input-group{
    width: 20%;
}
.zm-form-item__content {
    word-break: break-all;
}
.zm-form-item__content span {
    word-wrap: break-word;
    word-break: break-all;
}
.zm-date-editor.zm-input, .zm-date-editor.zm-input__inner {
    /* width: 400px; */
    height: 32px;
    line-height: 28px;
}
.zm-select .zm-select-input .zm-select-prefix {
    position: absolute;
    color: #747487;
    left: 5px;
}
/* .select-with-prefix .zm-select-input__inner {
    padding-left: 20px;
}
.select-with-prefix.zm-select .zm-select-input.has-slot .zm-select-span__inner {
    padding-left: 20px;
} */
</style>
